import moment from "moment-timezone";
import { properties } from "./mappings";
import StatsConfigs from "./../../../configs/stats";
import _ from "lodash";

const valuesToStr = {
  //mappings + translation
  mappings: {
    product_range_properties: properties
  },
  //translations
  "0": "non",
  "1": "oui",
  rupt_only: "rupture uniquement",
  with_rupt: "avec rupture",
  without_rupt: "sans rupture",
  pres: "Présent",
  miss: "Manquant",
  gain: "Gain",
  loss: "Perte"
};
const filters = {
  /**
   * get filters as obj
   * @example {
   *   Réimplanté : ["oui"],
   *   Marque: ["SENSODYNE"]
   * }
   * @param filters
   * @param period
   */
  getValues: (filters = {}, period = []) => {
    const filtersKeys = Object.keys(filters);
    const startDate = moment(period[0]).format("DD/MM/YYYY");
    const endDate = moment(period[1]).format("DD/MM/YYYY");
    const values = {};
    values.period = {
      start: startDate,
      end: endDate
    };

    const dimensions = StatsConfigs.dimensions;
    for (let i = 0; i < filtersKeys.length; i++) {
      const filtersKey = filtersKeys[i];
      const dimension = _.find(dimensions, { id: filtersKey }) || {};
      //get label from id
      let filtersKeyLabel = dimension.label || filtersKey;

      const filter = filters[filtersKey] || {};
      filter.values = filter.values || [];
      filter.dataSelected = filter.dataSelected || [];
      if (filter.values.length === 0) {
        continue;
      }
      values[filtersKeyLabel] = [];
      for (let j = 0; j < filter.values.length; j++) {
        const value = filter.values[j];
        const dataItem = _.find(filter.dataSelected, { id: value });

        if (valuesToStr.mappings.hasOwnProperty(filtersKey)) {
          const mappings = valuesToStr.mappings[filtersKey] || {};
          const mappingsValue = mappings[value] || {};
          values[filtersKeyLabel].push(mappingsValue.value_fr || "");
        } else if (dataItem && dataItem.hasOwnProperty("value")) {
          values[filtersKeyLabel].push(dataItem.value);
        } else if (valuesToStr.hasOwnProperty(value)) {
          values[filtersKeyLabel].push(valuesToStr[value]);
        }
      }
    }
    return values;
  },
  /**
   * Extract filters relevant to the given kpi
   * @param filters
   * @param kpi
   * @return {Object} extractedFilters
   */
  extractFilters: (filters, kpi = {}) => {
    const dimensions = StatsConfigs.dimensions || [];
    const filtersKeys = Object.keys(filters);
    const extractedFilters = {};
    for (let i = 0; i < filtersKeys.length; i++) {
      const filtersKey = filtersKeys[i];
      const dimensionItem = dimensions.find(v => v.id === filtersKey);
      if (
        filtersKey === "client_id" || //always put client_id filter
        (dimensionItem && (!dimensionItem.display || dimensionItem.display(kpi)))
      ) {
        extractedFilters[filtersKey] = filters[filtersKey];
      }
    }
    return extractedFilters;
  },
  /**
   * Extract default filters from configs
   * @param kpi
   * @return {}
   */
  getDefaultFilters: kpi => {
    const defaultFilters = {};
    const dimensions = StatsConfigs.dimensions || [];
    for (let i = 0; i < dimensions.length; i++) {
      const dimension = dimensions[i];
      if (!dimension.display || (dimension.display && dimension.display(kpi))) {
        if (dimension.defaultValue) {
          defaultFilters[dimension.id] = dimension.defaultValue;
        }
      }
    }

    return defaultFilters;
  }
};

export default filters;



// WEBPACK FOOTER //
// src/modules/stats/core/filters.js